import {
  faCoffee, faCaretDown ,faMapPin, faPaperPlane, faTruck, faSignOutAlt,
  faHome, faUsers, faUser, faHouseUser, faSitemap, faGlobeAmericas,
  faShoppingBag, faTasks, faCogs, faBuilding, faGlobeEurope, faParachuteBox, faTimes, faCircle
} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'


export const GetLabelColor = (status) => {
  const colors = {
    Complete: "green",
    Pending: "orange",
    Inprogress: "teal"
  }
  return colors[status] || "grey"
}

export const mapIcon = (iconName) => {
  const icons = {
    "faHome": faHome,
    "faUsers": faUsers,
    "faUser": faUser,
    "faTruck": faTruck,
    "faPaperPlane": faPaperPlane,
    "faHouseUser": faHouseUser,
    "faSitemap": faSitemap,
    "faGlobeAmericas": faGlobeAmericas,
    "faTasks": faTasks,
    "faCogs": faCogs,
    "faShoppingBag": faShoppingBag,
    "faBuilding": faBuilding,
    "faCoffee": faCoffee,
    "faGlobeEurope": faGlobeEurope,
    "faParachuteBox": faParachuteBox,
    "faSignOutAlt": faSignOutAlt,
    "faTimes": faTimes,
    "faCircle": faCircle,
    "faWhatsapp": faWhatsapp,
    "faCaretDown": faCaretDown,
  }
  return icons[iconName] || faMapPin;
}

export async function validatePhoto(file) {
  // debugger
  if (!file || !file[0].type.includes('image'))
    return false

  let x = await toBase64(file[0])
  // debugger
  return x
}

export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export const formatDate = date => {
  const MonthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"]

  return `${date.getDate()} ${MonthNames[date.getMonth()]} ${date.getFullYear()}`
}